import { ReactElement, RefObject, useEffect, useState } from 'react';

import mapboxgl from 'mapbox-gl';

import { BottomLeftFloatingLoadingSpinner } from 'features/spinner/Spinner';

export function MapLoadingSpinner({
  currentRefMap,
  mapReady,
}: {
  currentRefMap: RefObject<mapboxgl.Map>;
  mapReady: boolean;
}): ReactElement {
  const [showMapLoading, setShowMapLoading] = useState(true);

  useEffect(() => {
    if (!currentRefMap.current) {
      return;
    }

    const LOADING_EVENT = 'dataloading';
    const LOADED_EVENT = 'idle';

    currentRefMap.current.on(LOADING_EVENT, (e) => {
      // do not show loading when event is repeated (e.g. hovered route)
      if (!e.isSourceLoaded) setShowMapLoading(true);
      else setShowMapLoading(false);
    });

    currentRefMap.current.on(LOADED_EVENT, () => {
      setShowMapLoading(false);
    });

    if (currentRefMap.current.loaded()) {
      setShowMapLoading(false);
    }
  }, [mapReady]); // TODO OS-337 remove dependence on mapReady, pass map as state instead of ref

  return showMapLoading && <BottomLeftFloatingLoadingSpinner />;
}
